

module.exports = __webpack_require__.stylable.create(
    "Hashtags2065123858",
    {"classes":{"root":"Hashtags2065123858__root","textTitle":"Hashtags2065123858__textTitle","title":"Hashtags2065123858__title"},"vars":{},"stVars":{"DefaultFont":"\"{theme: 'Body-M', size:'24px' }\"","HashtagsFont":"\"fallback(font(--hashtagsFont), font({theme: 'Body-M', size:'24px' }))\"","HashtagsTextColor":"\"fallback(color(--hashtagsTextColor), color(color-5))\"","HashtagsBgColor":"\"fallback(color(--hashtagsBgColor), color(color-1))\""},"keyframes":{}},
    "",
    16,
    "Hashtags2065123858",
    null
);
